import React, { useState } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
//import BildHeader from "../../images/services/services/header.jpg"
import BildHeader from "../../images/schwarz-optik/schwarz-optik-header.jpg"
import BildOben from "../../images/services/services/oben.jpg"
import Bild1 from "../../images/services/services/1.jpg"
import AppStoreBadge from "../../assets/appstore.svg"
import PlayStoreBadge from "../../assets/playstore.svg"
import AppIcon from "../../assets/appicon.png"
import SubNavigation from "../../components/SubNavServices"
import Termin from "../../components/Termin"

const ServicesSubpage: React.FC = () => {
  const siteTitle = "Services – Dienstleistungen"
  const [isSubMenuOpen, setSubMenuOpen] = useState(false)

  return (
    <Layout title={siteTitle}>
      <SEO title={siteTitle} />
      <section className="wrapper">
        <div className="headerImage">
          <img src={BildHeader} />
        </div>
      </section>
      <Termin />
      <SubNavigation
        isSubMenuOpen={isSubMenuOpen}
        setSubMenuOpen={setSubMenuOpen}
        activeMenuText="Services"
      />
      <section className="wrapper greyColor content">
        <h1>Services</h1>
        <h2 className="contentSubtitle">SCHWARZ Optik – Seit 1992 in Heiden</h2>
        <div className="contentColumns">
          <div className="contentColumn">
            <div className="imageCollection">
              <div className="imageRow">
                <img src={Bild1} />
              </div>
            </div>
            <p className="imageCaption">
              SCHWARZ Optik Heiden bietet Ihnen eine Verträglichkeitsgarantie
              auf alle im eigenen Atelier gefertigten Brillen und stellt dazu
              einen persönlichen Brillenpass aus.
            </p>
            <div className="appCallout">
              <br /><h2>
                <strong>Haben Sie schon Ihre</strong> Schwarz Optik App?
              </h2>
              <p>
                Mit unserer kostenlosen App haben Sie alles im Blick: Ihre
                Brillenwerte, Termine, Ihr Brillenpass – einfach auf dem Handy.
                Praktisch, sicher und jederzeit griffbereit.<br />
                Willkommen bei SCHWARZ Optik.
              </p>
              <div className="storeBadges">
                <img src={AppIcon} alt="Schwarz Optik App Icon" className="appIcon" />
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/details?id=de.ipro.sinnoclone.schwarzOptik&hl=de_CH"
                >
                  <img src={PlayStoreBadge} alt="Google Play Store" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://apps.apple.com/ch/app/schwarz-optik-die-kunden-app/id6473427324?l=de-DE"
                >
                  <img src={AppStoreBadge} alt="Apple App Store" />
                </a>
              </div>
            </div>
          </div>
          <div className="contentColumn">
            <h2>Kompetenz für gesundes Sehen</h2>
            <p>
              Seit 1992 stehen bei SCHWARZ Optik Sie als Mensch im Fokus. Deshalb endet unsere Arbeit nicht mit der fertigen Sehhilfe– wir begleiten Sie darüber hinaus mit einem Service, der mitdenkt. Fachlich fundiert, technisch auf dem neuesten Stand und immer mit einem offenen Ohr für Ihre Wünsche.
            </p>
            <p>
              Unser engagiertes Team arbeitet mit modernster Infrastruktur und bildet sich laufend weiter – für höchste Qualität bei Beratung, Sehanalyse und Versorgung. Ob Alltag, Beruf oder Freizeit: Wir finden mit Ihnen gemeinsam Lösungen, die wirklich zu Ihrem Leben passen.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default ServicesSubpage
